<template>
  <v-container class="fill-height" style="opacity:0.9" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="12" md="12">
        <h1 class="custom-title">404 - Page Not Found</h1>
        <p class="err-p">
          The page you are looking for might have been removed <br />had its
          name changed or is temporarily unavailable!
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      source: String
    },
    data() {
      return {}
    }
  }
</script>

<style>
  .err-p {
    font-size: 1.7em;
    line-height: 1.5em;
  }
  .custom-title {
    font-size: 50px;
  }
  .custom-lnk {
    text-decoration: none;
  }
  .custom-lnk:hover {
    color: #333;
    text-decoration: none;
  }
</style>
